// Copyright (c) 2016 Deere & Company

import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateUserSecurity = (state, action) =>
    Security.update(state, {
        $set: action.security
    });

export default (state = getDefaultState().security, action) => {

    const actionTypes = {
        [actions.UPDATE_USER_SECURITY_SUCCESS]: updateUserSecurity
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/user/shared/reducers/security.js